export default {
  text: {
    en: 'Your discount has been applied<br />Congratulations!',
  },
}
